module.exports = __webpack_public_path__ + "static/media/carLoader.57541f1e.gif";